import React from 'react'
import WhoWeAreImage from '../../../assets/images/image1.webp';
import Image from "../../elements/Image";

const WhoWeAre = ({data}) => {
  return (
    <>
      <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4 pt-28">
        <div className="relative flex items-start gap-60">
          <div className="relative w-2/5 z-10">
            <div className="relative w-full aspect-3/2 overflow-hidden rounded-3xl z-10">
              <Image
                src={WhoWeAreImage}
                width="100%"
                height="100%"
                alt=""
                effect=""
                classes="object-cover"
              />
            </div>
            <div className="absolute top-0 left-0 h-full w-full flex justify-between z-0">
              <div className="absolute top-10 -left-20 border-[35px] rounded-full border-[#043C29] b max-w-full w-[288px] h-[288px]"></div>
              <div className="absolute -bottom-16 -right-28 border-[35px] rounded-full border-[#043C29] b max-w-full w-[389px] h-[389px]"></div>
            </div>
          </div>
          <div className="relative w-3/5 z-10">
            <h4 className="text-xl font-semibold mb-2 text-primary uppercase">{data.SubTitle}</h4>
            <h2 className="text-5xl text-white font-semibold mb-3">{data.title}</h2>
            <div className="text-xl leading-relaxed text-secondary">
              
               <p dangerouslySetInnerHTML={{ __html: data.description }} />
            </div>
          </div>
          <div className="absolute inset-0 -translate-x-40 m-auto w-[800px] h-[800px] rounded-full bg-radial-custom z-0"></div>
        </div>
      </div>
    </>
  )
}

export default WhoWeAre